import { last, get } from "lodash-es";
export class EventTranslatePlugin {
  constructor(transFlow) {
    this.translateFlow = {};
    this.translateFlow = transFlow;
  }
  translate(translateRes, object) {
    if (translateRes.place[0] !== 'events') return;
    const pathParts = translateRes.translatePath || translateRes.place;
    const pathArrayReduced = pathParts.reduce((path, node, index) => {
      if (last(path) === 'steps') {
        const stepIndex = parseInt(`${node}`, 10);
        if (!isNaN(stepIndex)) {
          path.pop();
          path.push(`步骤${stepIndex + 1}`);
          return path;
        }
      }
      if (last(path) === 'params') {
        const flowStep = get(object, translateRes.place.slice(0, index - 1));
        const flowType = get(flowStep, 'type', '');
        const translate = this.translateFlow[flowType];
        if (translate) {
          path.pop();
          path.push(translate);
          return path;
        }
      }
      // flow中的展示索引都是已1开始的 主要是针对branch的分支索引写了这个
      if (parseInt(`${node}`, 10) === 0) {
        path.push(1);
        return path;
      }
      path.push(node);
      return path;
    }, []);
    // 这里为了性能优化 直接改输入了
    // eslint-disable-next-line no-param-reassign
    translateRes.translatePath = pathArrayReduced;
  }
}
//# sourceMappingURL=TranslateEventsPlugin.js.map
